var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SelectModal", {
    ref: "selectModal",
    attrs: {
      title: _vm.$t("group.editModal.title.users"),
      all: _vm.allUsers,
      selected: _vm.selectedUsers,
      label: t => _vm.formatUserName(t),
      emptyText: _vm.$t("general.none"),
      showFooterButtons: true
    },
    on: {
      selected: function($event) {
        return _vm.$emit("selected", _vm.selectedUsers)
      },
      add: _vm.onAddUser,
      remove: _vm.onRemoveUser
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }